const SearchIcon = ({
  style,
  color,
  scale,
}: {
  color?: string;
  scale?: number;
  style?: React.CSSProperties;
}) => {
  let c = "#fff";
  if (color) c = color;
  return (
    <svg
      style={{ ...style, transform: `scale(${scale})` }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group_1337" data-name="Group 1337" transform="translate(-0.356)">
        <g id="Iconly_Broken_Search" data-name="Iconly/Broken/Search" transform="translate(0.356)">
          <g id="Search">
            <path
              id="Search-2"
              data-name="Search"
              d="M19.756,18.607l-3.437-3.361h0l-.081-.123a.809.809,0,0,0-1.137,0h0a8.113,8.113,0,0,1-10.519.34A7.679,7.679,0,0,1,2.876,5.31,8.075,8.075,0,0,1,12.953,2.342a7.741,7.741,0,0,1,4.314,9.385.779.779,0,0,0,.182.772.822.822,0,0,0,.774.232.8.8,0,0,0,.593-.54h0a9.334,9.334,0,0,0-5-11.25A9.754,9.754,0,0,0,1.689,4.085,9.256,9.256,0,0,0,3.049,16.28a9.789,9.789,0,0,0,12.535.515l3.044,2.976a.819.819,0,0,0,1.137,0,.784.784,0,0,0,0-1.12h0Z"
              transform="translate(0 0)"
              fill={c}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SearchIcon;

export const SearchIcon2 = ({
  style,
  color,
  scale,
}: {
  color?: string;
  scale?: number;
  style?: React.CSSProperties;
}) => {
  let c = "#AEAEAE";
  if (color) c = color;
  return (
    <svg
      style={{ ...style, transform: `scale(${scale})` }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86255 8.71924H9.2603L9.04684 8.51341C9.79394 7.64434 10.2437 6.51608 10.2437 5.28871C10.2437 2.55191 8.0253 0.333496 5.28849 0.333496C2.55167 0.333496 0.333252 2.55191 0.333252 5.28871C0.333252 8.02551 2.55167 10.2439 5.28849 10.2439C6.51586 10.2439 7.64413 9.79414 8.5132 9.04705L8.71903 9.2605V9.86275L12.5308 13.6668L13.6666 12.5309L9.86255 8.71924ZM5.28849 8.71924C3.39025 8.71924 1.85794 7.18694 1.85794 5.28871C1.85794 3.39048 3.39025 1.85818 5.28849 1.85818C7.18672 1.85818 8.71903 3.39048 8.71903 5.28871C8.71903 7.18694 7.18672 8.71924 5.28849 8.71924Z"
        fill={c}
      />
    </svg>
  );
};
